import React from "react";
import { STATUS_COLORS } from "../../Dashboard/constants/labels";
import styles from "../styles/campaignNotifications.module.scss";

export default function SendStatusBadge({ status }) {
  const normalized = String(status || "").toLowerCase();

  return (
    <span
      className={styles.badge}
      style={{
        backgroundColor: STATUS_COLORS[normalized] || "#6c757d",
      }}
    >
      {normalized || "—"}
    </span>
  );
}
